import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/CommitDetailsPopupViewQuery$parameters';
import type { CommitDetailsPopupViewQuery } from '@atlassian/jira-relay/src/__generated__/CommitDetailsPopupViewQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

/**
 * @deprecated This component is deprecated. Please use the component from
 * "@atlassian/jira-development-board-commit-details-popup-new" package instead.
 */
export const commitDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			commitDetailsForIssue: CommitDetailsPopupViewQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-commit-details-popup" */ './src/ui/commit-details-popup-view/CommitDetailsPopupView.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			commitDetailsForIssue: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
